import { BG_COLORS, FONT_COLORS } from "../../constants";
import { Stack, SvgIconProps, StackProps } from "@mui/material";
import { ReactNode } from "react";

type TFilledIconProps = {
  renderIcon: (props: SvgIconProps) => ReactNode;
  stackProps?: StackProps;
  width?: number;
  height?: number;
  success?: boolean;
};

export const FilledIcon = ({
  stackProps,
  renderIcon,
  width = 20,
  height = 20,
  success,
}: TFilledIconProps) => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      width={width}
      height={height}
      borderRadius="50%"
      bgcolor={success ? BG_COLORS.primary : BG_COLORS.error}
      {...stackProps}
    >
      {renderIcon({
        sx: {
          width: height * 0.75,
          height: height * 0.75,
          color: FONT_COLORS.white,
        },
      })}
    </Stack>
  );
};

export default FilledIcon;
